import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { DocumentCard, FileImg } from './style';
import {
  getFileExtension,
  getIconByExtension,
} from '../../../../utils/fileExtension';
import Text from '../../Text';
import { timestampToDate } from '../../../../utils/common';
import { formatFileSize } from '../../../../utils/formatFileSize';
import CTA from '../../CTA';

const CardInnerDocument = ({
  mediaIsPhone,
  mediaIsTablet,
  item,
  onClick,
  children,
  className,
}) => {
  const [file, setFile] = useState();

  useEffect(() => {
    if (item?.file?.filename) setFile(item?.file);
    else if (item?.file_info?.filename) setFile(item?.file_info);
  }, [item]);

  if (mediaIsPhone || mediaIsTablet) {
    return (
      <DocumentCard className={className}>
        <Text type="h3.5">Titolo</Text>
        <Text type="h3" className="title">
          {item?.name || item?.title}
        </Text>
        <Text type="h3.5">Formato</Text>
        <FileImg
          src={getIconByExtension(
            getFileExtension(item?.name) || file?.extension
          )}
        />
        <Text type="h3.5">Tipologia</Text>
        <Text type="b4" className="ellipsis">
          {!item?.document_typology && '-'}
          {(item?.document_typology || []).map((t, i) => (
            <span key={`typology-${i}`}>
              {i > 0 && <span> - </span>}
              {t?.name}
            </span>
          ))}
        </Text>
        <Text type="h3.5">Data</Text>
        <Text type="b5" className="date" color="#515151">
          {item?.id
            ? timestampToDate(item?.created)
            : timestampToDate(item?.lastModified, undefined, true)}
        </Text>
        <Text type="h3.5">Dimensioni</Text>
        <Text type="b5" className="size" color="#8B8B8B">
          {formatFileSize(item?.size || file?.size)}
        </Text>
        <div />
        {children || (
          <CTA
            btnText="Elimina"
            icon="trash-03"
            type="tertiary"
            onClick={onClick}
            bottomRight
          />
        )}
      </DocumentCard>
    );
  }

  return (
    <DocumentCard className={className}>
      <FileImg
        src={getIconByExtension(
          getFileExtension(item?.name) || file?.extension
        )}
      />
      <Text type="h3" className="title">
        {item?.name || item?.title}
      </Text>
      <Text type="b4" className="ellipsis">
        {!item?.document_typology && '-'}
        {(item?.document_typology || []).map((t, i) => (
          <span key={`typology-${i}`}>
            {i > 0 && <span> - </span>}
            {t?.name}
          </span>
        ))}
      </Text>
      <Text type="b5" className="date" color="#515151">
        {item?.id
          ? timestampToDate(item?.created || item?.last_saved)
          : timestampToDate(item?.lastModified, undefined, true)}
      </Text>
      <Text type="b5" className="size" color="#8B8B8B">
        {formatFileSize(item?.size || file?.size)}
      </Text>
      {children || (
        <CTA
          btnText="Elimina"
          icon="trash-03"
          type="tertiary"
          onClick={onClick}
        />
      )}
    </DocumentCard>
  );
};

CardInnerDocument.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  item: PropTypes.object,
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default withMediaQueries(CardInnerDocument);
